import React from 'react';

type SvgProps = {
  strokeColor?: string;
};

const AgriPartnerIcon: React.FC<SvgProps> = ({ strokeColor = '#CBD2D9' }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28 16.0938V17.3338C27.9966 23.2387 24.1097 28.4381 18.4471 30.1124C12.7846 31.7866 6.69519 29.5369 3.48127 24.5833C0.267357 19.6296 0.694486 13.152 4.53103 8.66326C8.36758 4.17451 14.6996 2.74387 20.0933 5.14717"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.3333 5.33398L14.6667 20.0007L10.6667 16.0007"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default AgriPartnerIcon;
